import { BlogList } from "@/features/blog/components/BlogList";
import { notionBlogDbIds } from "@/features/blog/consts/notionBlogDbIds";
import { blogPageMapper } from "@/features/blog/helpers/blogPageMapper";
import { BlogPost } from "@/features/blog/type";
import { Title } from "@/features/common/components/Title";
import { SiteLayout } from "@/features/layout/SiteLayout";
import { getPublicConfig } from "@/helpers/getPublicConfig";
import { dbQuery } from "@/services/notion/dbQuery";

type BlogListProps = {
  blogPosts: BlogPost[];
};

const { env } = getPublicConfig();

function Blog(props: BlogListProps) {
  const { blogPosts } = props;

  return (
    <div className="mx-4 max-w-screen-md py-8 sm:pt-12 sm:pb-24 md:mx-auto md:w-full">
      <Title size="h2" className="font-normal text-gray-900">
        網誌
      </Title>

      <BlogList blogPosts={blogPosts} />
    </div>
  );
}

export const getServerSideProps = async () => {
  const blogDbId = env.isProduction
    ? notionBlogDbIds.production
    : notionBlogDbIds.preview;

  const blogPosts = await dbQuery(blogDbId, {
    filter: {
      property: "status",
      select: { equals: "Public" },
    },
    sorts: [{ property: "Display Date", direction: "descending" }],
    mapper: blogPageMapper,
  });

  return {
    props: { blogPosts },
  };
};

export default Blog;

Blog.getLayout = function getLayout(page) {
  return <SiteLayout>{page}</SiteLayout>;
};
